module.exports = __webpack_public_path__ + "img/microplastics-process-2.da92c3c1.png";